import { useGlobalSearchParams } from "expo-router";

import { api } from "~/utils/api";
import { IconPaymentError } from "~/component/feature/paywall/icons/icon-payment-error";
import { IconPaymentSuccess } from "~/component/feature/paywall/icons/icon-payment-success";
import { PaymentInfoScreen } from "~/component/feature/paywall/payment-info-screen";

const PaymentSuccessPage = () => {
  const { ph_link_id } = useGlobalSearchParams<{ ph_link_id?: string }>();
  //background ensure with status of payment
  const { data } = api.payments.getPaymentStatus.useQuery(
    {
      id: ph_link_id ?? "",
    },
    {
      enabled: !!ph_link_id,
      refetchInterval: (data) => {
        return data?.status === "ACTIVE" || data?.status === "PENDING"
          ? 10000
          : false;
      },
    },
  );

  if (
    data?.status === "EXPIRED" ||
    data?.status === "FAILED" ||
    data?.status === "DELETED"
  ) {
    return (
      <PaymentInfoScreen
        title={"Не вдалося здійснити оплату"}
        text={
          "Платіж не був завершений. Спробуйте ще раз або скористайтеся іншим способом оплати."
        }
        icon={<IconPaymentError />}
      />
    );
  }

  return (
    <PaymentInfoScreen
      title={"Оплата успішна"}
      text={
        "Дякуємо! Платіж пройшов успішно. Ви можете продовжити роботу з платформою."
      }
      disabled={ph_link_id ? data?.status !== "USED" : false}
      icon={<IconPaymentSuccess />}
    />
  );
};

export default PaymentSuccessPage;
